import Game from "../../../../../../src/Game";
import SupplAngleLine, { SupplAngle } from "../../entities/SupplAngleLine";
import { rootEventBus, EnumRootEventBus } from "../../../../../../src/managers/RootEventBus";
import { drawSupplAngle } from "./helpers/drawHelpers";
import { generateAnglePoints } from "../../../../../../src/utils/generator/generateAnglePoints";
import { generateAngles } from "../../../../../../src/utils/generator/generateAngles";
import { Coord } from "../../../../../../src/types/Interface";
import { ANGLE_COLORS } from "../../types/Config";


export default class SupplAngleManager {
  private Game = Game.getInstance();
  SupplAngleLines: SupplAngleLine[] = [];
  private SupplAngles: SupplAngle[] = [];
  private SupplAnglesTotal: SupplAngle[] = [];
  constructor() {
    this.addSupplAngles();
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }
  setAllVisible = (v: boolean) => this.SupplAngleLines.forEach(l => l.setVisible(v));
  isVertical() {
    const dim = this.Game.getDim();
    return dim.WIDTH < dim.HEIGHT;
  }
  generateCoords() {
    const isVertical = this.isVertical();
    const dim = this.Game.getDim();
    let coords = [
      { x: 150, y: 350 },
      { x: 150, y: 400 }
    ]
    if (isVertical) {
      coords = [
        {
          x: dim.WIDTH / 2 - 215,
          y: dim.HEIGHT / 2 + 250,
        },
        {
          x: dim.WIDTH / 2 + 185,
          y: dim.HEIGHT / 2 + 250
        }
      ]
    }
    return coords;
  }
  addSupplAngles() {
    const coords = this.generateCoords();
    const l1 = new SupplAngleLine(coords[0], ["sa-1", "sa-3", "sat-1", "sat-3"], [ANGLE_COLORS[0], ANGLE_COLORS[2]]);
    const l2 = new SupplAngleLine(coords[1], ["sa-2", "sa-4", "sat-2", "sat-4"], [ANGLE_COLORS[1], ANGLE_COLORS[3]]);
    const angles = [l1.getSupplAngle(), l2.getSupplAngle()];

    this.SupplAngleLines = [l1, l2];

    this.SupplAngles = [angles[0][0], angles[1][0], angles[0][1], angles[1][1]]
    this.SupplAnglesTotal = [angles[0][2], angles[1][2], angles[0][3], angles[1][3]]
  }
  draw(pointArr: Coord[], clockwise: boolean) {
    const points = generateAnglePoints(pointArr);
    const degree1 = generateAngles(points[0], clockwise).degree;
    const degree2 = generateAngles(points[1], clockwise).degree;
    const degrees = [degree1, degree2, 180 - degree1, 180 - degree2];

    pointArr.forEach((p, pI) => {
      const prevP = pointArr[pI == 0 ? pointArr.length - 1 : pI - 1];
      const nextP = pointArr[pI == pointArr.length - 1 ? 0 : pI + 1];

      drawSupplAngle(this.SupplAngles[pI], { curr: p, prev: prevP, next: nextP }, degrees[pI], clockwise, pI < 2);
      drawSupplAngle(this.SupplAnglesTotal[pI], { curr: p, prev: prevP, next: nextP }, degrees[pI], clockwise, pI < 2);
    })
  }
}